var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import useService from "./useService";
import AdvisorService from "../../Services/Advisor.service";
/**
 * Custom hook to fetch institution-specific terminology for advisor and coach
 */
export const useTermsToRepresent = () => {
    const [termsToRepresentState, loadTermsToRepresent] = useService(() => __awaiter(void 0, void 0, void 0, function* () {
        const [termToRepresentAdvisor, termToRepresentCoach] = yield Promise.all([
            AdvisorService.getTermForAdvisor(),
            AdvisorService.getTermForCoach(),
        ]);
        return {
            termToRepresentAdvisor,
            termToRepresentCoach,
        };
    }));
    React.useEffect(() => {
        loadTermsToRepresent();
    }, [loadTermsToRepresent]);
    return termsToRepresentState;
};
